import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import AttackButton from '../AttackButton';
import RetreatButton from '../RetreatButton';
import PowerButtons from '../Powers/PowerButtons';
import DiscardFromPlayButton from '../Trainer/DiscardFromPlayButton';
import ContextMenu from '../ContextMenu';
import CardDetail from '../ContextMenu/CardDetail';
import { conversionBadges } from '../Card/conversions';
import { ACTIVE } from '../ActiveGame/contextMenuTypes';
import { selectActivePokemon, selectPlayer } from '../ActiveGame/selectors';

const ActivePokemonMenu = ({ userId }) => {
  const activePokemon = useSelector((state) => selectActivePokemon(state, { userId }));
  const player = useSelector(selectPlayer);

  if (!activePokemon) {
    return null;
  }

  const mine = userId === player.getIn(['user', 'id']);
  const name = activePokemon.getIn(['card', 'name'], 'Active Pokémon');

  return (
    <ContextMenu menu={ACTIVE} userId={userId} title={mine ? name : `Opponent's ${name}`}>
      <CardDetail
        card={activePokemon.get('card')}
        damage={activePokemon.get('damage')}
        energyAttachments={activePokemon.get('energyAttachments')}
        protection={activePokemon.get('protection')}
        hindrance={activePokemon.get('hindrance')}
        hinderedBy={activePokemon.get('hindered_by')}
        trainers={activePokemon.get('trainers')}
        conversions={conversionBadges(activePokemon)}
      >
        {mine && <PowerButtons card={activePokemon.get('card')} at="active" />}
        {mine && <DiscardFromPlayButton at="active" name={name} />}
        <AttackButton userId={userId} />
        <RetreatButton userId={userId} />
      </CardDetail>
    </ContextMenu>
  );
};

ActivePokemonMenu.propTypes = {
  userId: PropTypes.number.isRequired,
};

export default ActivePokemonMenu;
